import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  action,
  className = '',
}: SectionHeadingProps) {
  return (
    <div className={`flex items-end justify-between gap-4 flex-wrap ${className}`}>
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}